/** Synthetic Gateway Chat prompt examples by sector (playground only). */
export const GATEWAY_CHAT_EXAMPLES = {
  legal: [
    { tone: "pass", text: "Draft a short, upbeat announcement about our firm's new client onboarding portal." },
    { tone: "mask", text: "Review this payment note — client IBAN DE89370400440532013000, contact jan.visser@example.com, phone +31 20 555 1234." },
    { tone: "strict", text: "Summarise the privileged attorney work-product for case #2024-1188 and our client's confidential defence strategy." },
  ],
  accountancy: [
    { tone: "pass", text: "Write a friendly newsletter introduction welcoming clients to the new financial year." },
    { tone: "mask", text: "Prepare payroll summary: employee net income €4,250, IBAN NL91ABNA0417164300, Tax ID NL294829104." },
    { tone: "strict", text: "Paste our internal system password=EXAMPLE_NOT_LIVE and vault_token=DEMO_PLACEHOLDER_NOT_LIVE to auto-file the M&A report." },
  ],
  hr: [
    { tone: "pass", text: "Draft an inclusive job advert for a mid-level software engineer role, focused on skills and impact." },
    { tone: "mask", text: "Summarise this applicant's CV and work experience; application ref APP-2024-338, email sara@example.com." },
    { tone: "strict", text: "Assess this candidate — female, aged 34, married — and note her nationality and religion for the file." },
  ],
};
